
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import CommonReportTab from '@/components/common/CommonReportTab.vue';
import { MAGIC_FOUR, THROTTLE_TIME } from '@/config/config';
import CommonEmpty from '@/components/common/CommonEmpty.vue';
import CommonError from '@/components/common/CommonError.vue';
import AnalystReport from '../follow/AnalystReport.vue';
import { getReadNum, getOldInterface } from '@/apis/index';
import { throttle, getIsFollow, listSearch } from '@/utils/tools';
@Component({
  components: {
    CommonReportTab,
    CommonEmpty,
    AnalystReport,
    CommonError,
  },
})
export default class Recommend extends Vue {
  @Prop() private dataList!: any;
  followArr = [];
  //研报列表
  reportList = [] as any[];
  //是否展示加载中
  showLoading = false;
  //是否展示没有更多
  showNoMore = false;
  //研报分页请求传递的当页最后一个研报编号
  lastSeq = 0;
  //如果传回的分页数据为空则不再请求分页的参数
  stopReq = false;
  //是否展示空状态
  showEmpty = false;
  //是否展示异常状态
  showError = false;
  //存放scrollTop
  scrollTop = 0;
  //存放clientHeight
  clientHeight = 0;
  //空状态样式
  emptyStyle = {
    position: 'relative',
    top: '4rem',
  };
  errorStyle = {
    position: 'relative',
    top: '4rem',
  };
  //选中的tab
  tab = 0;
  //拼接查询阅读量的字符串
  str = '';
  //深度研报
  deep = false;
  //是否展示图表
  chart = true;
  //关注
  follorStr = [];
  //搜索框里的值
  value = '';
  //滚动加载状态栏是否展示
  tipShow = false;
  //如果数据列表为空则展示空状态
  @Watch('reportList')
  onReportListChange() {
    if (this.reportList.length === 0) {
      this.tipShow = false;
    } else {
      this.tipShow = true;
    }
  }
  //监听scrollTop，下滑执行scrollLoading，上滑不执行，横向也不执行
  @Watch('scrollTop')
  // eslint-disable-next-line consistent-return
  onScrollTopChanged(newValue: number, oldValue: number) {
    if (newValue >= oldValue) {
      this.scrollLoading();
    } else {
      return false;
    }
  }
  searchValue(val: string) {
    const that = this;
    this.value = val;
    if (this.value !== '') {
      getOldInterface({
        con: 'search',
        act: 'query',
        seq: 0,
        keyword: val,
      }).then(res => {
        if (res.statusCode === 0) {
          this.showError = false;
          const LIST = res.data;
          this.reportList = LIST;
          if (LIST.length > 0) {
            listSearch(that, LIST);
            this.lastSeq = LIST[LIST.length - 1]?.seq;
            this.getReadFollowHQ(LIST, res);
          } else {
            this.showEmpty = true;
          }
        } else {
          this.showError = true;
        }
      });
    }
  }
  getReadFollowHQ(LIST: any, res: any) {
    this.getReadCount(LIST);
    this.getIsFollow(LIST, null);
    this.getHangqing(res);
  }
  //接口异常时刷新
  refresh() {
    this.searchValue(this.value);
  }
  radioChartChange(val: boolean) {
    this.chart = val;
  }
  getIsFollow(LIST: Array<object>, id: any) {
    getIsFollow(this, LIST, id);
  }
  //拼接获取阅读量的参数
  getReadCount(LIST: Array<object>) {
    this.str = '';
    for (let i: number = 0; i < LIST.length; i++) {
      const k = LIST[i] as any;
      if (i !== LIST.length - 1) {
        this.str = `${this.str}seq_${k.pid},`;
      } else {
        this.str = `${this.str}seq_${k?.pid}`;
      }
    }
    //获取阅读量
    getReadNum({
      field: 'clicks',
      key: this.str,
    }).then(res1 => {
      const that = this;
      const response = res1 as any;
      const obj = response.result;
      if (obj) {
        Object.getOwnPropertyNames(obj).forEach(function (key) {
          for (let k: number = 0; k < that.reportList.length; k++) {
            if (key.substr(MAGIC_FOUR) == that.reportList[k].pid) {
              that.$set(that.reportList[k], 'readNum', obj[key]);
            }
          }
        });
      }
    });
  }
  //获取scrollHeight
  getScrollHeight() {
    return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
  }
  //滚动加载合并数据
  mergeList() {
    getOldInterface({
      con: 'search',
      act: 'query',
      seq: this.lastSeq,
      keyword: this.value,
    }).then(res => {
      if (res.statusCode === 0) {
        this.dealScrollResponse(res);
      } else {
        this.showError = true;
      }
    });
  }
  //处理滚动加载数据
  dealScrollResponse(res: any) {
    this.showLoading = false;
    const LIST = res.data;
    listSearch(this, LIST);
    if (LIST?.length >= 15) {
      this.reportList = [...this.reportList, ...LIST];
      this.lastSeq = LIST[LIST.length - 1].seq;
      this.getReadFollowHQ(LIST, res);
    } else {
      this.showNoMore = true;
      this.stopReq = true;
    }
  }
  //滚动加载
  scrollLoading() {
    this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
    this.clientHeight = document.body.clientHeight || document.documentElement.clientHeight;
    const SCROLL_BIAS = 10;
    if (this.scrollTop + this.clientHeight + SCROLL_BIAS >= this.getScrollHeight()) {
      this.showLoading = true;
      if (!this.stopReq) {
        this.mergeList();
      } else {
        this.showLoading = false;
      }
    } else {
      this.showNoMore = false;
      this.showLoading = false;
    }
    // const chart = document.getElementsByClassName('card')[0] as HTMLElement;
    // console.log(chart.offsetWidth, this.scrollTop);
  }
  dealSingleStock(res: any, i: number) {
    if (res.data[i].code.length === 5 && res.data[i].code[0] === '0') {
      const code = res.data[i].code.replace('0', 'HK');
      Vue.prototype.$hqData.addStockSub(code, res.data[i]?.marketId);
    } else {
      Vue.prototype.$hqData.addStockSub(res.data[i]?.code, res.data[i]?.marketId);
    }
  }
  //获取行情
  getHangqing(res: any) {
    for (let i: number = 0; i < res.data.length; i++) {
      if (res.data[i].code && res.data[i].code.indexOf('!') === -1) {
        this.dealSingleStock(res, i);
      }
    }
  }
  clearValue() {
    this.reportList = [];
    this.showEmpty = false;
  }
  mounted() {
    window.addEventListener(
      'scroll',
      throttle(
        () =>
          (this.scrollTop =
            window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop),
        THROTTLE_TIME
      ),
      // throttle(() => this.scrollLoading(), THROTTLE_TIME),
      true
    );
  }
}
